import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Paper from '@material-ui/core/Paper';
import { DataGrid, ToolbarOptions } from 'tubular-react';
import { ColumnModel } from 'tubular-common';
import { styles, toolbarConfig } from './styles';
import { formatCurrency } from '../../../../utils/numberFormatter';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const columns = [
  new ColumnModel('Wallet', { Searchable: true }),
  new ColumnModel('Balance', { Searchable: false }),
  new ColumnModel('Target', { Searchable: false })
];

const toolbarOptions = new ToolbarOptions(toolbarConfig);

function SimpleTable(props) {
  const { classes } = props;

  const data = props.list.map(d => ({
    Wallet: d.wallet,
    Balance: formatCurrency(d.balance.balance || 0),
    Target: formatCurrency(d.high_balance_agent_threshold || 0)
  }));

  return (
    <React.Fragment>
      <DialogTitle id="max-width-dialog-title" className={classes.title}>
        <Grid container justify="space-between">
          <Grid item>High Balance Agents</Grid>
          <Grid item>
            <Typography variant="subtitle2">
              Last Update:{' '}
              {`${new Date(
                props.summary.last_dh_stock_update
              ).toDateString()}, ${new Date(
                props.summary.last_dh_stock_update
              ).toLocaleTimeString()}`}
            </Typography>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Paper className={classes.root} id="popup-details-table">
          <DataGrid
            columns={columns}
            dataSource={data}
            gridName="Distribution House"
            bottomPager={false}
            toolbarOptions={toolbarOptions}
          />
        </Paper>
      </DialogContent>
    </React.Fragment>
  );
}

SimpleTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SimpleTable);
